import _ from 'lodash';
import CED_SFTP_DIR from '../../models/cedSftpDir';
import CED_SFTP_USER from '../../models/cedSftpUser';
import CED_SFTP_PASS from '../../models/cedSftpPass';
import BUIP_TYPE_INTEGRATION from '../../models/buipType';
import MATRIX_INTEGRATION_ID from '../../models/matrixIntegration.js';
import MATRIX_INTEGRATION_XID from '../../models/matrixIntegrationXid.js';
import COUNTRY_CODE_INTEGRATION from '../../models/countryCodeIntegration.js';
import LICENSING_TYPE_INTEGRATION from '../../models/licensingTypeIntegration.js';
import ORG_MATCH_TYPE_INTEGRATION from '../../models/orgMatchTypeIntegration.js';
import REPLACE_AFFILIATIONS_INTEGRATION from '../../models/replaceAffiliationsIntegration.js';

class CreateCustomerController {
  constructor(customerService, $state, customerIntegrationsService) {
    this.name = 'createCustomer';
    this.$state = $state;
    this.canProceed = false;
    this.existingOrgId = null;
    this.existingOrgXid = null;
    this.existingCustomer = null;
    this.isValidExistingCustomer = false;
    this.customerIntegrationsService = customerIntegrationsService;
    this.customerService = customerService;
    this.errors = {};

    this.setIntegrations();
    this.setCustomer();
  }

  setIntegrations() {
    this.matrixIntegrationId = angular.copy(MATRIX_INTEGRATION_ID);
    this.matrixIntegrationXid = angular.copy(MATRIX_INTEGRATION_XID);
  }


  setCustomer() {
    this.customer = {
      customerIntegrations: []
    };
  }

  validateOrganization() {
    this.errors = {};
    if (this.matrixIntegrationXid.value && this.matrixIntegrationXid.value.length >= 3) {
      this.customerService.getOrganization(this.matrixIntegrationXid.value).then((response) => {
        this.matrixIntegrationXid.value = response && response.data && response.data.xid;
        this.matrixIntegrationId.value = response && response.data && response.data.id;
        this.customer.customerIntegrations = [
          [LICENSING_TYPE_INTEGRATION, BUIP_TYPE_INTEGRATION, CED_SFTP_USER, CED_SFTP_PASS, CED_SFTP_DIR],
          [COUNTRY_CODE_INTEGRATION, ORG_MATCH_TYPE_INTEGRATION, REPLACE_AFFILIATIONS_INTEGRATION, this.matrixIntegrationId, this.matrixIntegrationXid]
        ];
        this.validateCustomer();
      }).catch(() => {
        this.errors = {
          orgId: 'Invalid Org Id'
        };
      });
    }
  }

  getExistingCustomer() {
    this.existingCustomer = null;
    if (this.customer && this.customer.name) {
      this.customerService.getCustomers(0, 1, this.customer.name, false, true).then((response) => { 
        this.existingCustomer = response && response.data && response.data.content && response.data.content.length && response.data.content[0];
        this.validateCustomer();
      }).catch(() => {
        this.existingCustomer = null;
      });
    }
  }

  validateCustomer() {
    this.canProceed = false;
    this.clearErrors();
    this.customer.name = _.trim(this.customer.name);
    if (this.existingCustomer && _.toLower(this.existingCustomer.name) === _.toLower(this.customer.name)) {
      this.customerIntegrationsService.getAllIntegrations({
        customerId: this.existingCustomer.id, 
        showContentLoader: true
      }).then((response) => {
        const integrations = response && response.data && response.data.content || [];
        _.each(integrations, ({key, value})=> {
          if(key === 'orgId'){
            this.existingOrgId = value || null;
          } else if(key === 'orgXid') {
            this.existingOrgXid = value || null;
          }
        });
        if (!_.isNil(this.existingOrgXid) && this.existingOrgXid !== this.matrixIntegrationXid.value || !_.isNil(this.existingOrgId) && !this.matrixIntegrationXid.value.endsWith(this.existingOrgId)) {
          this.errors.name = 'CUSTOMER_NAME_DUPLICATE';
        } else {
          this.isValidExistingCustomer = true;
        }
        this.canProceed = true;
      }).catch(() => {
        this.existingOrgId = null;
        this.existingOrgXid = null;
        this.canProceed = true;
      });
    } else {
      this.canProceed = true;
    }
  }

  submitCustomer() {
    if (this.existingCustomer && this.isValidExistingCustomer) {
      this.configureCustomer(this.existingCustomer);
    } else if (this.customer && this.customer.customerIntegrations.length) {
      this.customerService.createCustomer(this.customer).then(
        this.onCustomerCreated.bind(this),
        this.onCustomerCreationFailed.bind(this)
      );
    }
  }

  onCustomerCreated(response) {
    this.clearErrors();
    this.customerWasCreated = true;
    this.customer = response.data;
    this.configureCustomer(this.customer);
  }

  configureCustomer(customer) {
    customer.isCreated = true;
    this.$state.go('home.tools', {
      customer
    });
  }

  clearErrors() {
    this.errors = {};
  }

  onCustomerCreationFailed(response) {
    let error = response.data.error;
    this.clearErrors();

    if (error.name === 'SequelizeUniqueConstraintError') {
      this.handleNameError();
    } else {
      this.handleKeyError(error);
    }
  }

  handleKeyError(error) {
    let errorKeys = error.name.split('.')[1].split(',');

    errorKeys.forEach((errorKey) => {
      this.errors[errorKey] = error.message;
    });
  }

  ableToSubmit() {
    let nameIsValid = this.customer.name && this.customer.name.length > 2 && this.customer.name.length < 255;
    let orgId = this.matrixIntegrationXid.value && this.matrixIntegrationXid.value.length > 0;
    return this.canProceed && nameIsValid && orgId && !this.errors.orgId && !this.errors.name;
  }

  resetCustomerCreate() {
    this.setCustomer();
    this.setIntegrations();
    this.setCustomerStatus();
    this.clearErrors();
    this.customerWasCreated = false;
  }
}

CreateCustomerController.$inject = ['customerService', '$state', 'customerIntegrationsService'];

export default CreateCustomerController;



// WEBPACK FOOTER //
// ./app/components/createCustomer/createCustomer.controller.js